import { buildModelManager } from "../builder.js";
const DefaultAiModelRateSelection = {
  __typename: true,
  id: true,
  createdAt: true,
  lastSyncedAt: true,
  model: true,
  notes: true,
  pencePerInputToken: true,
  pencePerOutputToken: true,
  provider: true,
  source: true,
  updatedAt: true
};
const modelApiIdentifier = "aiModelRate";
const pluralModelApiIdentifier = "aiModelRates";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAiModelRateSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAiModelRateSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAiModelRateSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAiModelRateSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAiModelRateSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAiModelRateSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAiModelRateSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByModel",
    findByField: "model",
    findByVariableName: "model",
    modelApiIdentifier,
    defaultSelection: DefaultAiModelRateSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByModel",
    findByField: "model",
    findByVariableName: "model",
    modelApiIdentifier,
    defaultSelection: DefaultAiModelRateSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "aiModelRateGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const AiModelRateManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultAiModelRateSelection,
  operations
);
export {
  AiModelRateManager,
  DefaultAiModelRateSelection
};
//# sourceMappingURL=AiModelRate.js.map
